import {
  WecomInnerContact,
  WecomMessageType,
  WecomOuterContact,
  WecomRoom,
  SendingStatus,
  WS_RESPONSE_MESSAGE_TYPE,
  sortMemberList,
  WecomConversationDataType,
  ChannelTypeEnum,
} from "../..";
import {
  WecomConversationStatusChangeData,
  WecomErrorData,
  WecomLoginSuccessData,
  WecomReceiveLoginQRCodeData,
  WecomRecovateMessageData,
  WecomRemoveCustomerToRoomData,
  WecomScanningQRCodeData,
  WecomUnreadNumUpdateData,
  WecomVerifyVerificationCodeData,
} from "./ws-types";
import chatSdkHooks from "../../hooks";
import { WSResponseData } from "../../request/ws";

const waitingWorks = [] as WSResponseData[];

function handlePushWaitWorks(data: WSResponseData) {
  waitingWorks.push(data);
}
export function wsHandler(data: WSResponseData) {
  if (data.type) {
    handlePushWaitWorks(data);
  }
}

// @ts-ignore
window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    const start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };

window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  };

function handlePopWaitWorks() {
  window.requestIdleCallback(
    () => {
      const work = waitingWorks.shift();
      if (work) {
        const { data, type, user_id, client_id, ip, error } = work;
        switch (type) {
          case WS_RESPONSE_MESSAGE_TYPE.RECEIVE_LOGIN_QRCODE:
            handleReceiveLoginQRCode(
              data as WecomReceiveLoginQRCodeData,
              client_id,
              ip
            );
            break;
          case WS_RESPONSE_MESSAGE_TYPE.SCANING:
            handleScanningLoginQRCode(data as WecomScanningQRCodeData, error);
            break;
          case WS_RESPONSE_MESSAGE_TYPE.VERIFY_VERIFICATION_CODE: {
            handleVerifyVerificationCode(
              data as WecomVerifyVerificationCodeData
            );
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.LOGIN_SUCCESS:
            handleLoginSuccess(data as WecomLoginSuccessData);
            break;
          case WS_RESPONSE_MESSAGE_TYPE.LOGIN_OUT:
          case WS_RESPONSE_MESSAGE_TYPE.CLIENT_CLOSE: {
            handleLogout(user_id, data?.quit_reason);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.GET_ROOM_DETAIL: {
            handleGetRoomDetail(data as WecomRoom, user_id);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.RECEIVE_MESSAGE:
          case WS_RESPONSE_MESSAGE_TYPE.OTHER_TERMINAL_RECEIVE_MESSAGE:
          case WS_RESPONSE_MESSAGE_TYPE.REVOCATION_MESSAGE_NOTICE:
          case WS_RESPONSE_MESSAGE_TYPE.FILE_DOWNLOAD_SUCCESS_NOTICE:
          case WS_RESPONSE_MESSAGE_TYPE.VOICE_TO_TEXT_NOTICE: {
            handleReceiveMessage(data as WecomMessageType, user_id);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.REVOCATION_MESSAGE_SUCCESS_NOTICE: {
            handleRevocateMessage(data as WecomRecovateMessageData);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.CONVERSATION_CHANGE: {
            handleConversationChange(data as WecomConversationDataType);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.CONVERSATION_STATUS_CHANGE: {
            handleConversationStatusChange(
              data as WecomConversationStatusChangeData
            );
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.GET_CONTACT_DETAIL: {
            handleGetContactDetail(
              data as WecomOuterContact | WecomInnerContact,
              user_id
            );
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.REMOVE_CUSTOMER_TO_CREATE_ROOM:
          case WS_RESPONSE_MESSAGE_TYPE.REMOVE_CUSTOMER_TO_CREATED_ROOM: {
            handleRemoveCustomerToRoom(data as WecomRemoveCustomerToRoomData);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.UNREAD_NUM_UPDATE: {
            handleUnreadNumUpdate(data as WecomUnreadNumUpdateData);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.ERROR: {
            handleError(data as WecomErrorData);
            break;
          }
        }
      }
      handlePopWaitWorks();
    },
    { timeout: 100 }
  );
}
handlePopWaitWorks();

/** 接收登录二维码信息 **/
function handleReceiveLoginQRCode(
  data: WecomReceiveLoginQRCodeData,
  client_id: number,
  ip?: string
) {
  chatSdkHooks.common.receiveLoginQRCodeHook.emit({
    channelType: ChannelTypeEnum.Wecom,
    data: {
      ...data,
      ip,
      client_id,
      url: `/api/damselfish-chat-bot/command/qrCode/QW/${data?.login_qrcode_key}`,
    },
  });
}

/** 监听扫码，此时接口会返回扫码过程中的用户信息 */
function handleScanningLoginQRCode(
  data: WecomScanningQRCodeData,
  error?: number
) {
  console.log("正在扫码");
  chatSdkHooks.common.scaningHook.emit({
    channelType: ChannelTypeEnum.Wecom,
    data: { ...data, error },
  });
}

/** 验证验证码返回的结果 */
function handleVerifyVerificationCode(data: WecomVerifyVerificationCodeData) {
  chatSdkHooks.common.verifyVerificationCodeHook.emit({
    channelType: ChannelTypeEnum.Wecom,
    data,
  });
}

/** 登录成功之后将用户信息存放到db */
function handleLoginSuccess(data: WecomLoginSuccessData) {
  chatSdkHooks.common.loginSuccessHook.emit({
    channelType: ChannelTypeEnum.Wecom,
    user_id: data?.user_id,
  });
}

function handleLogout(user_id: string, quit_reason: string = "") {
  chatSdkHooks.common.logoutHook.emit({
    channelType: ChannelTypeEnum.Wecom,
    user_id,
    quit_reason,
  });
}

/**
 * 处理接收到的最新群信息
 */
function handleGetRoomDetail(data: WecomRoom, from_user_id: string) {
  chatSdkHooks.wecom.getRoomDetailHook.emit({
    ...data,
    member_list: sortMemberList(data?.member_list || [], data?.room_owner_id),
    from_user_id,
    id: `${from_user_id}_${data.room_id}`,
  });
}

/**
 * 处理接收到的最新联系人信息
 */
function handleGetContactDetail(
  data: WecomOuterContact | WecomInnerContact,
  from_user_id: string
) {
  chatSdkHooks.wecom.getContactDetailHook.emit({
    ...data,
    from_user_id,
    id: `${from_user_id}_${data.user_id}`,
  });
}

/** 监听接收到的消息 */
function handleReceiveMessage(data: WecomMessageType, from_user_id: string) {
  chatSdkHooks.wecom.receiveMessageHook.emit({
    ...data,
    from_user_id,
    sending_status: SendingStatus.SUCCESS,
  });
}

/** 撤回消息 */
function handleRevocateMessage(data: WecomRecovateMessageData) {
  chatSdkHooks.wecom.revocateMessageHook.emit(data);
}

/** 处理会话变更 */
function handleConversationChange(data: WecomConversationDataType) {
  chatSdkHooks.wecom.conversationChangeHook.emit(data);
}

/** 处理会话状态变更 */
function handleConversationStatusChange(
  data: WecomConversationStatusChangeData
) {
  // 未读数变化不在这里做处理，在conversationChangeHook已经有通知了
  const effectiveData = {
    data: data?.data
      ?.filter((item) => item?.unread === undefined || item?.unread === null)
      ?.map((item) => {
        Object.entries(item).forEach(([key, value]) => {
          if (value === undefined || value === null) {
            delete item[key as keyof typeof item];
          }
        });
        return item;
      }),
    request_key: data?.request_key,
  };

  chatSdkHooks.wecom.conversationStatusChangeHook.emit(effectiveData);
}

function handleRemoveCustomerToRoom(data: WecomRemoveCustomerToRoomData) {
  chatSdkHooks.wecom.removeCustomerToRoomHook.emit(data);
}

function handleUnreadNumUpdate(data: WecomUnreadNumUpdateData) {
  chatSdkHooks.wecom.unreadNumUpdateHook.emit(data);
}

function handleError(data: WecomErrorData) {
  chatSdkHooks.common.wsErrorHook.emit({
    channelType: ChannelTypeEnum.Wecom,
    message: data.error_msg,
  });
}
